export default __webpack_public_path__ + "static/media/html.baddf735.png";